import listReducer from './list/reducer';

export default {
  productList: listReducer,
};
